import { graphql } from "gql.tada";

const AvailabilitySearchFragment = graphql(`
  fragment AvailabilitySearchFragment on AvailabilitySearch {
    __typename
    id
    restaurantId
    available
    dataStatus
    syncExpires
    availableTimes {
      __typename
      time
      date
      session
      available
      cutOffTime
      leaveTime
      options
      deal
      dealDescription
    }
  }
`);

export default AvailabilitySearchFragment;
